"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Texture_1 = require("../tree/Texture");
class ImageTexture extends Texture_1.Texture {
    constructor() {
        super(...arguments);
        this._src = undefined;
        this._hasAlpha = false;
    }
    get src() {
        return this._src;
    }
    set src(v) {
        if (this._src !== v) {
            this._src = v;
            this._changed();
        }
    }
    get hasAlpha() {
        return this._hasAlpha;
    }
    set hasAlpha(v) {
        if (this._hasAlpha !== v) {
            this._hasAlpha = v;
            this._changed();
        }
    }
    _getIsValid() {
        return !!this._src;
    }
    _getLookupId() {
        return this._src;
    }
    _getSourceLoader() {
        const src = this._src;
        const hasAlpha = this._hasAlpha;
        return (cb) => {
            return this.stage.platform.loadSrcTexture({ src, hasAlpha }, cb);
        };
    }
    getNonDefaults() {
        const obj = super.getNonDefaults();
        if (this._src) {
            obj.src = this._src;
        }
        return obj;
    }
}
exports.ImageTexture = ImageTexture;
//# sourceMappingURL=ImageTexture.js.map